import { triggerAnalyticsEvent } from 'helpers/analytics'
import { ReactElement } from 'react'
import { redirectTo } from 'ui/customHooks/useHistory'
import { HeaderNavLinkProps } from './typing'
import { HeaderMenuText, MenuItem, MenuLink } from './subcomponents'

const HeaderNavLink = ({ linkItem }: HeaderNavLinkProps): ReactElement => {
  const { path, linkName } = linkItem
  return (
    <MenuItem key={path}>
      <MenuLink
        onClick={(): void => {
          redirectTo(path)
          triggerAnalyticsEvent({
            pageKind: ''
          })
        }}
        data-test="menu-link"
        buttonType="text"
      >
        <HeaderMenuText>{linkName}</HeaderMenuText>
      </MenuLink>
    </MenuItem>
  )
}

export default HeaderNavLink
